
import { defineComponent } from "vue";
import {
  ICapSuaChuaResponseBase,
  ITaiKhoanKeToanResponse,
} from "@/core/interfaces/ApiResponses";
import { CapSuaChuaService } from "@/core/services/CapSuaChuaService.service";
import { swalErrNotification } from "@/core/helpers/utils";
import { generateTablePdf } from "@/core/helpers/generate-table-pdf";
import PdfViewerPage from "@/components/shared/pdf-viewer/PdfViewerPage.vue";
import { PDF_GENERATE_TABLE_DEFAULTS } from "@/components/shared/pdf-viewer/pdf-content.config";
import { pickDonViPdfExtra } from "@/components/shared/pdf-viewer/pdf-document-header";

const CAP_SUA_CHUA_PDF_COLUMNS = [
  { header: "STT", width: 22, align: "center" as const },
  { header: "Cấp S/C", width: 70, align: "left" as const },
  { header: "Tên viết tắt", width: 35, align: "left" as const },
  { header: "T/tin tài khoản", width: 90, align: "left" as const },
  { header: "Mô tả", width: 56, align: "left" as const },
];

export default defineComponent({
  name: "CapSuaChuaListViewer",

  components: { PdfViewerPage },

  data() {
    return {
      items: [] as ICapSuaChuaResponseBase[],
      searchTerm: "",
      pdfSource: null as string | null,
      isGenerating: false,
      tenDonVi: "",
      tenDonViCha: "",
    };
  },

  computed: {
    pdfFileName(): string {
      return "danh-sach-cap-sua-chua.pdf";
    },
  },

  methods: {
    taiKhoanDisplay(tk?: ITaiKhoanKeToanResponse | null): string {
      if (!tk) return "-";
      return `${tk.matk} / ${tk.mact || "-"} / ${tk.tentk}`;
    },

    async loadAndGenerate() {
      const queryS = this.$route.query.s;
      this.searchTerm = typeof queryS === "string" ? queryS : "";

      try {
        this.isGenerating = true;
        this.pdfSource = null;

        const listResult = await CapSuaChuaService.listAll({
          s: this.searchTerm,
        });
        this.items = listResult.items;
        const { tenDonVi, tenDonViCha } = pickDonViPdfExtra(listResult.extra);
        this.tenDonVi = tenDonVi;
        this.tenDonViCha = tenDonViCha;
        this.pdfSource = await this.generatePdf();
      } catch (e) {
        swalErrNotification(e, "Có lỗi khi tải danh sách cấp sửa chữa");
      } finally {
        this.isGenerating = false;
      }
    },

    async generatePdf(): Promise<string> {
      const rows = this.items.map((item, index) => [
        String(index + 1),
        item.ten_cap_sc ?? "",
        item.ten_viet_tat || "-",
        this.taiKhoanDisplay(item.tk_ketoan),
        item.mo_ta || "-",
      ]);

      return generateTablePdf({
        ...PDF_GENERATE_TABLE_DEFAULTS,
        title: "DANH SÁCH CẤP SỬA CHỮA",
        subtitle: this.searchTerm ? `Từ khóa: ${this.searchTerm}` : undefined,
        columns: CAP_SUA_CHUA_PDF_COLUMNS,
        rows,
        documentHeader: {
          tenDonVi: this.tenDonVi,
          tenDonViCha: this.tenDonViCha,
          variant: "masterList",
        },
      });
    },
  },

  mounted() {
    this.loadAndGenerate();
  },
});
